import DisplayVideos from "./DisplayVideos";
import Top from "./Top";
import End from "./End";
import React from "react";

import './stylesheets/A1.css';

import 'bootstrap/dist/css/bootstrap.css';
// Put any other imports below so that CSS from your
// components takes precedence over default styles.

function A1() {
    return (
      <div className="A1">

        <Top />

        <DisplayVideos />

        <End />

      </div>
    );
  }
  
  export default A1;